module.exports = __webpack_public_path__ + "static/media/WU_ThreeVerticalDots.2aa2a01d.svg";